// extracted by mini-css-extract-plugin
export default {"wordpressPCMenu":"Wordpress_wordpressPCMenu__37Tg2","wordpressPhoneMenu":"Wordpress_wordpressPhoneMenu__ybMef"};